module.exports = __webpack_public_path__ + "media/images/saturation-e86f1dc2.png";